// extracted by mini-css-extract-plugin
export default {"button":"button--oEEVv","adjustment":"adjustment--wKmkZ","fadeSlideUp":"fadeSlideUp--lOVOL"};